import React from 'react';
import './About.css' 

const About = (props) => {
    
    return (
        <React.Fragment>
            <div class="text-center mb-5 pb-5 border-b border-slate-200">
                <div class="text-slate-700 text-2xl font-cormorant tracking-wide">ABOUT</div>
                <div class="max-w-4xl m-auto">
                    Experienced software engineer who is naturally curious with an insatiable desire to learn something new every&nbsp;day.
                    <br />
                    An efficient, analytical, challenge loving, problem solver and&nbsp;troubleshooter. 
                </div>
            </div>
        </React.Fragment>
    )
}

export default About;